export const dataOurTeam =[
{
    id:'1',
    title:'Directors',
team:[
{
    id:'1',
    name:'Mr. P.S. Shekar',
    position:'Managing Director',
    text:'At sps we treat employees with respect and value their contributions. Recognize their achievements, both publicly and privately, and provide constructive feedback to help them grow professionally.'
},


]
},
{
    id:'2',
    title:'Management',
team:[
{
    id:'1',
    name:'Mr. K.R. Premkumar',
    position:'President - Operations',
    text:'At sps we  ensure clear and open communication with employees.support employees in their roles by providing the necessary resources, training'
},
{
    id:'2',
    name:'Mr. R. Satheesh',
    position:'GM - Marketing',
    text:'At sps we plan, execute, and evaluate marketing campaigns to reach target audiences and achieve marketing objectives. '
},
{
    id:'3',
    name:'Mr. K. Divakar',
    position:'GM - Designs',
    text:'At sps we plan, execute, and evaluate marketing campaigns to reach target audiences and achieve marketing objectives. '
},
{
    id:'6',
    name:'Mr. M. Ravi',
    position:'DGM – Procurement',
    text:'At sps we plan, execute, and evaluate marketing campaigns to reach target audiences and achieve marketing objectives. '
},
{
    id:'7',
    name:'Mr. C.S Sudarsan',
    position:'DGM – Accounts',
    text:'At sps we plan, execute, and evaluate marketing campaigns to reach target audiences and achieve marketing objectives. '
},
{
    id:'8',
    name:'Mr. P. Sakthivel / Mr. M. Vivek',
    position:'Plant in Charge',
    text:'At sps we plan, execute, and evaluate marketing campaigns to reach target audiences and achieve marketing objectives. '
},
{
    id:'9',
    //name:'Mr. D. Sridhar',
    position:'Manager - HR',
    text:'At sps we plan, execute, and evaluate marketing campaigns to reach target audiences and achieve marketing objectives. '
},
]
}
]